import { useState } from "react";
import { Link, useLocation, matchPath } from "react-router-dom";
import "../utils/tailwind.css";
import { useStore } from "../utils/context";
import Modal from "../components/modal";
import Const from "../utils/constant";
import { LogOut, X } from "lucide-react";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const isActiveTab = (tab) =>
    matchPath({ path: tab, end: true }, location.pathname);

  const { handleLogout } = useStore();
  const [isModalOpen, setIsOpenModal] = useState(false);

  const layoutMenu = Const.MENU_ITEMS.LAYOUT;
  const menu = Const.MENU_ITEMS.PAGES;
  const masterMenu = Const.MENU_ITEMS.MASTER_PAGES;
  const miscMenu = Const.MENU_ITEMS.MISC;

  const handleLogoutClick = () => {
    handleLogout();
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-[1040] lg:hidden backdrop-blur-sm transition-opacity"
          onClick={onClose}
        />
      )}

      <div
        className={`fixed lg:sticky top-[65px] left-0 z-[1045] h-[calc(100vh-65px)] w-[250px] bg-[#1a1a4e] transition-transform duration-300 ease-in-out flex flex-col border-r border-white/5 shadow-2xl lg:shadow-none ${isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
          }`}
      >


        <button
          onClick={onClose}
          className="lg:hidden absolute top-4 right-4 p-2 text-white/50 hover:text-white transition-colors"
        >
          <X size={20} />
        </button>

        <div className="flex-1 overflow-y-auto custom-scrollbar px-2 py-3 space-y-6">
          {menu.length > 0 && (
            <div>
              <div className="px-3 mb-3 text-[10px] font-bold text-white/30 uppercase tracking-[2px]">Screens</div>
              <div className="space-y-1">
                {menu.map((item) => {
                  const isActive = isActiveTab(item.link);
                  return (
                    <Link
                      key={item.id}
                      to={item.link}
                      onClick={() => window.innerWidth < 1024 && onClose()}
                      className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-[13.5px] font-medium transition-all group ${isActive
                        ? "bg-gradient-to-r from-[#FCBB32]/20 to-[#FCBB32]/5 text-[#FCBB32] shadow-sm"
                        : "text-white/60 hover:text-white hover:bg-white/5"
                        }`}
                      style={{ textDecoration: "none" }}
                    >
                      <item.icon size={18} className={`${isActive ? "text-[#FCBB32]" : "text-white/40 group-hover:text-white/80"}`} />
                      {item.label}
                      {isActive && <div className="ml-auto w-1.5 h-1.5 rounded-full bg-[#FCBB32] shadow-[0_0_8px_#FCBB32]" />}
                    </Link>
                  );
                })}
              </div>
            </div>
          )}

          {layoutMenu.length > 0 && (
            <div>
              <div className="px-3 mb-3 text-[10px] font-bold text-white/30 uppercase tracking-[2px]">Layout</div>
              <div className="space-y-1">
                {layoutMenu.map((item) => {
                  const isActive = isActiveTab(item.link);
                  return (
                    <Link
                      key={item.id}
                      to={item.link}
                      onClick={() => window.innerWidth < 1024 && onClose()}
                      className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-[13.5px] font-medium transition-all group ${isActive
                        ? "bg-gradient-to-r from-[#FCBB32]/20 to-[#FCBB32]/5 text-[#FCBB32] shadow-sm"
                        : "text-white/60 hover:text-white hover:bg-white/5"
                        }`}
                      style={{ textDecoration: "none" }}
                    >
                      <item.icon size={18} className={`${isActive ? "text-[#FCBB32]" : "text-white/40 group-hover:text-white/80"}`} />
                      {item.label}
                      {isActive && <div className="ml-auto w-1.5 h-1.5 rounded-full bg-[#FCBB32] shadow-[0_0_8px_#FCBB32]" />}
                    </Link>
                  );
                })}
              </div>
            </div>
          )}

          {/* Masters Section */}
          {masterMenu.length > 0 && (
            <div>
              <div className="px-2 mb-3 text-[10px] font-bold text-white/30 uppercase tracking-[2px]">Masters</div>
              <div className="space-y-1">
                {masterMenu.map((item) => {
                  const isActive = isActiveTab(item.link);
                  return (
                    <Link
                      key={item.id}
                      to={item.link}
                      onClick={() => window.innerWidth < 1024 && onClose()}
                      className={`flex items-center gap-3 px-4 py-2.5 rounded-xl text-[13.5px] font-medium transition-all group ${isActive
                        ? "bg-gradient-to-r from-[#FCBB32]/20 to-transparent text-[#FCBB32] shadow-sm"
                        : "text-white/60 hover:text-white hover:bg-white/5"
                        }`}
                      style={{ textDecoration: "none" }}
                    >
                      <item.icon size={18} className={`${isActive ? "text-[#FCBB32]" : "text-white/40 group-hover:text-white/80"}`} />
                      {item.label}
                      {isActive && <div className="ml-auto w-1.5 h-1.5 rounded-full bg-[#FCBB32] shadow-[0_0_8px_#FCBB32]" />}
                    </Link>
                  );
                })}
              </div>
            </div>
          )}

          {/* Misc Section */}
          {miscMenu.length > 0 && (
            <div>
              <div className="px-3 mb-3 text-[10px] font-bold text-white/30 uppercase tracking-[2px]">Miscellaneous</div>
              <div className="space-y-1">
                {miscMenu.map((item) => {
                  const isActive = isActiveTab(item.link);
                  return (
                    <Link
                      key={item.id}
                      to={item.link}
                      onClick={() => window.innerWidth < 1024 && onClose()}
                      className={`flex items-center gap-3 px-4 py-2.5 rounded-xl text-[13.5px] font-medium transition-all group ${isActive
                        ? "bg-gradient-to-r from-[#FCBB32]/20 to-transparent text-[#FCBB32] shadow-sm"
                        : "text-white/60 hover:text-white hover:bg-white/5"
                        }`}
                      style={{ textDecoration: "none" }}
                    >
                      <item.icon size={18} className={`${isActive ? "text-[#FCBB32]" : "text-white/40 group-hover:text-white/80"}`} />
                      {item.label}
                      {isActive && <div className="ml-auto w-1.5 h-1.5 rounded-full bg-[#FCBB32] shadow-[0_0_8px_#FCBB32]" />}
                    </Link>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* Bottom: Logout */}
        <div className="px-3 py-3 border-t border-white/5">
          <button
            className="w-full flex items-center gap-2 px-3 py-2 rounded-xl text-white/50 hover:bg-red-500/50 hover:text-red-400 font-semibold transition-all group"
            onClick={() => setIsOpenModal(true)}
          >
            <LogOut size={18} className="group-hover:scale-110 transition-transform" />
            Log Out
          </button>
        </div>
      </div>

      <Modal
        title="Confirm Logout"
        desc="Are you sure you want to exit the admin system?"
        isModalOpen={isModalOpen}
        setIsOpen={setIsOpenModal}
        handleSubmit={handleLogoutClick}
        confirmButtonLabel="Logout Now"
        variant="danger"
        size="sm"
      />
    </>
  );
};

export default Sidebar;
